export default (url) => {
  if (url && url[url.length - 1] === '/') {
    return url.substring(0, url.length - 1);
  }

  return url;
};
